<template lang="pug">
v-container(fluid px-0 fill-height class=" tw-items-start tw-content-start tw-overflow-x-hidden")
  kubiqa-website-themes-theme-g-components-shared-top-navigation(appBarBg="theme-g-header-container")
  div(class="tw-flex tw-flex-col tw-h-full tw-w-full tw-relative")
    v-row(align="start" justify="center" class="tw-z-0 tw-mt-3 theme-g-header-container")
      v-col(cols="12" lg="11" xl="10")
        div(class="tw-flex tw-relative tw-w-full tw-justify-center")
          div(class="tw-flex tw-absolute tw-w-11/12 ")
            v-img(
              :src="website.pages.home.background_image ? path(website.pages.home.background_image) : ''"
              class="tw-rounded-lg"
              aspect-ratio="2.1"
              class=""
            )
        div(class="tw-flex tw-relative tw-w-full tw-h-full tw-justify-center tw-pt-20")
          v-row(no-gutters align="end" class="py-0 my-0 mt-16")
            v-col
              v-row(no-gutters align="center" justify="space-around")
                v-col(cols="12")
                  div(class="tw-grid")
                    div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
                      kubiqa-website-shared-widget-editor(
                        page="home"
                        placement="call_out"
                        @content="(content) => (content != null ? ((defaultCallout = false), key++) : ((defaultCallout = true), key++))"
                      )
                    div(
                      v-if="defaultCallout"
                      :key="key"
                      class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle"
                    )
                      div(class="tw-h-full  tw-items-center tw-flex")
                        v-row(no-gutters justify="center")
                          v-col(cols="9")
                            span(class="tw-font-bold tw-text-white tw-text-2xl") Find your ideal home
              v-row(justify="center" align="end" class="tw-mb-20")
                v-col(cols="10")
                  div(class="tw-relative tw-z-20")
                    kubiqa-website-themes-theme-g-components-shared-floating-search-bar

    // Description

    v-row(no-gutters align="center" justify="space-around" class=" theme-g-description-container")
      v-col(cols="12" class="")
        div(class="tw-flex tw-relative")
          div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1  tw-w-full")
            kubiqa-website-shared-widget-editor(
              page="home"
              placement="description"
              @content="(content) => (content != null ? ((defaultDescription = false), key++) : ((defaultDescription = true), key++))"
            )
          div(v-if="defaultDescription" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
            div(class="tw-h-full  tw-items-center tw-flex")
              v-row(no-gutters justify="center")
                v-col(cols="9")
                  span(class="tw-font-bold tw-text-white tw-text-2xl") Description
  div(class="tw-flex tw-relative tw-flex-col")
    kubiqa-website-themes-theme-g-components-home-listings
    v-row
      v-col
  kubiqa-website-themes-theme-g-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      key: 0,
      defaultCallout: null,
      defaultDescription: null,
    };
  },
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
};
</script>
<style lang="scss">
.theme-g-header-container {
  background-color: #16222a;
}
.theme-g-description-container {
  background-color: #b4c2c7;
}
</style>
